<template>
  <div>
    <breadcrumb :routerList="[{to:'/chanp/companyPriceManage',title:'价格管理(客户)'},{title:'经销商定价信息'}]"/>
    <div class="h-content">
      <div class="h-row h-mrt0">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <div class="h-rowCon">
              <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-bottom:0.3rem">
                  <h1>基本信息</h1>
                </div>
                <div class="h-pieceCon2">
                  <div class="h-formLine weekplandetail14">
                    <el-form :model="zy" label-position="right" ref="zy" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">

                      <el-form-item label="经销商名称" class="h-elformWrap-2" prop="agentName">
                            <el-input v-model="zy.agentName" placeholder="请输入" readonly>
                                <i
                                    class="el-icon-search el-input__icon"
                                    slot="suffix"
                                    @click="openShoudf">
                                </i>
                            </el-input>
                      </el-form-item>
                      <el-form-item label="经销商编码" class="h-elformWrap-2" prop="agentCode">
                            <el-input placeholder="选择经销商自动带出" v-model="zy.agentCode" readonly></el-input>
                      </el-form-item>
                      <el-form-item label="销售区域" class="h-elformWrap-2" prop="salesregionName">
                            <el-input placeholder="选择经销商自动带出" v-model="zy.salesregionName" readonly></el-input>
                      </el-form-item>

                        <el-form-item label="直单附件" class="h-elformWrap-2" prop="upload" v-if="!isHsjOrKs">
                            <brupload
                                :refid="zy.fileid"
                                reftype="代理商注册-附件"

                                :showtime="false">
                            </brupload>
                        </el-form-item>

                        <el-form-item label="附件" class="h-elformWrap-2" prop="upload1" v-if="!isHsjOrKs">
                            <brupload
                                :limit="3"
                                :refid="kehufujian"
                                reftype="客户定价-附件"
                                @filecallback="fileBack1"
                                :uploadflag="true"
                                :delflag="true"
                                :showtime="false">
                            </brupload>
                        </el-form-item>



                    </el-form>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="h-rowBox ljjtablepaddings12" style="margin-top:30px;padding:0;" v-if="isOemProduct">
            <div class="h-rowCon" style="padding-bottom:0">
              <div class="h-pieceIn2" style="padding-left:0.26rem;">
                <div class="h-pieceTitle2"
                     style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                  <h1>采购价格</h1>
                </div>
              </div>
              <el-table
                  ref="multipleTable"
                  :data="oemTableData"
                  stripe
                  style="width: 100%"
                  :border="true">
                <el-table-column
                    type="index"
                    width="40"
                    label="#">
                </el-table-column>
                <el-table-column
                    prop="productName"
                    label="产品型号">
                </el-table-column>
                <el-table-column
                    prop="productId"
                    label="产品编码">
                </el-table-column>
                <el-table-column
                    prop="unitPrice"
                    label="采购价格">
                </el-table-column>
                <el-table-column
                    prop="currency"
                    label="币种">
                  <template slot-scope="scope">
                    {{scope.row.currency | dictname('YLCurrency')}}
                  </template>
                </el-table-column>
                <el-table-column
                    prop="customerCode"
                    label="供应商编码">
                </el-table-column>
                <el-table-column
                    prop="customerName"
                    label="供应商名称">
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="h-rowBox ljjtablepaddings12" style="margin-top:30px;padding:0;">
            <div class="h-rowCon" style="padding-bottom:0">
              <div class="h-pieceIn2" style="padding-left:0.26rem;">
                <div class="h-pieceTitle2"
                     style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                  <h1>定价信息</h1>
                </div>
              </div>
              <el-table
                  ref="multipleTable"
                  :data="tableData3"
                  stripe
                  style="width: 100%"
                  :border="true">

                <el-table-column
                    type="index"
                    width="40"
                    label="#">
                </el-table-column>
                <el-table-column
                    prop="leltypecode"
                    label="定价类型"
                    width="100">
                  <template slot-scope="scope">
                    <el-select class="h-tableInput"   v-model="scope.row.leltypecode" placeholder="请选择"
                                 style="width: 100%;">
                        <el-option  v-for="(item) in dingjialeixing"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            :disabled="item.disabled"
                           >
                        </el-option>
                      </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="materialCode"
                    label="物料编码"
                    :show-overflow-tooltip="true"
                    width="180">
                </el-table-column>
                  <el-table-column
                      prop="materialDescrition"
                      label="物料名称"
                      :show-overflow-tooltip="true"
                      width="180">
                  </el-table-column>

                <el-table-column
                    prop="currency"
                    label="币种"
                    min-width="160">
                  <template slot-scope="scope">
                    <el-select class="h-tableInput" v-model="scope.row.currency" style="width:100%"
                               :disabled="scope.row.ispass==1||scope.row.ispass==3||(!chongxintijiaoshow&&scope.row.ispass==4)"
                               :class="{'ljj_selectdisblednone':scope.row.ispass==1||scope.row.ispass==3||(!chongxintijiaoshow&&scope.row.ispass==4)}"
                               filterable>
                      <el-option v-for="item in bizhongListops" :key="item.code"
                                 :label="item.name" :value="item.code"
                                 :disabled="true">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="value"
                    label="价格"
                    width="100">
                  <template slot-scope="scope">
                      <el-input class="h-tableInput" v-model="scope.row.value" placeholder="" type="number"
                                :disabled="scope.row.ispass==1||scope.row.ispass==3"></el-input>

                  </template>
                </el-table-column>
                <el-table-column
                    prop="prodseries"
                    label="大类名称"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>


                <el-table-column
                    prop="startdate"
                    label="有效开始时间"
                    width="120">
                  <template slot-scope="scope">
                    <div v-if="scope.row.ispass==1||scope.row.ispass==3">
                      {{scope.row.startdate}}
                    </div>
                    <div v-else>
                      <el-date-picker
                          class="h-tableInput"
                          v-model="scope.row.startdate"
                          style="width: 100%;"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="开始日期"
                          @change="dateChange1(scope.row)">
                      </el-date-picker>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="effectivedate"
                    label="有效结束时间"
                    width="120">
                  <template slot-scope="scope">
                    <div v-if="scope.row.ispass==1||scope.row.ispass==3">
                      {{scope.row.effectivedate}}
                    </div>
                    <div v-else>
                      <el-date-picker
                          class="h-tableInput"
                          v-model="scope.row.effectivedate"
                          style="width: 100%;"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="结束日期"
                          @change="dateChange2(scope.row)">
                      </el-date-picker>
                    </div>
                  </template>
                </el-table-column>



                <el-table-column label="操作" fixed="right" width="150">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" class="h-tableLink h-btn"
                               @click="delPlan(scope.$index,scope.row)">删除
                    </el-button>
                    <el-button v-if="scope.row.instid" type="text" size="small" class="h-tableLink h-btn" @click="chakanjindu(scope.row.instid)">跟踪</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!--<div class="h-tableAdd" @click="add_dingjia">-->
              <!--<a>新增定价</a>-->
              <!--</div>-->
              <div class="h-tableAdd" @click="showProcuct1">
                <a>新增产品</a>
              </div>
            </div>
          </div>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="showinstid"/>
        <!--经销商-->
        <shoudf
            :visible.sync="showshdfdialog"
            v-if="showshdfdialog"
            @choseObj="choseAgent"
            oneflag
            :ddlx="ddlx"
            title="选择经销商"/>
          <!--物料-->
          <wxwl
              :visible.sync="showwuliaodialog1"
              v-if="showwuliaodialog1"
              @choseObj="selectListByCode"
              :usercode="zy.agentCode"
              :ddlx="ddlx"
               currencyCode="CNY"
              :customerChannelCode="zy.customerChannelCode"
              :areaCode="zy.salesregion"
              title="选择物料"/>
      </div>
      <div class="h-txtCenter h-mrt60">
          <el-button class="h-btn h-bBtn h-bgwhite" @click="quxiao">返回</el-button>
          <el-button class="h-btn h-bBtn h-bggreen" @click="dingjiaanniu(0)" v-if="!chongxintijiaoshow">暂存
          </el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="dingjiaanniu(1)" v-if="!resubmit">确认提交
          </el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="dingjiaanniu(2)" v-if="resubmit">重新提交
          </el-button>

      </div>
    </div>
  </div>
</template>
<script>
import ss from '../../api/SystemService';
import shoudf from "@/components/dialog/selectshdf.vue";
import uploaddown from '../../utils/updownfile';
import wxwl from "@/components/dialog/wxwl.vue";
export default {
  components: {wxwl, shoudf},
  data() {
    let that = this
    return {
      kehufujian: null,
      LevelName: [],
      //批量导入
      uploaddownexcelflag: false,
      isOemPrice: true,
      isOemProduct: false,
      //区域list
      YlSalesAreawaioxiaolist: [],

      //币种
      bizhongListops: [],

      chongxintijiaoshow: false,
      //ywid
      ywid: null,
      //instid
      instid: null,
      showinstid: null,
      showhistory: false,
      //taskid
      taskid: null,
      YLCurrencyList: [],
      fanhuizancun: [],
      bianlianga: '',

      isHsjOrKs: true, //物料是海盛杰或者康盛

      //查询定价集合
      dingjiajihe: [],
      q: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      //币种
      bizhonglist: [],
      //区域
      YlSalesArea: [],
      //前页转发内容
      chanpinneirong: {},
      //定价id
      dingjiaid: '',
      dingjialeixing: [
        {
          value: 2,
          label: '外贸',
          disabled: true
        }, {
          value: 1,
          label: '内销'
        }, {
          value: 0,
          label: '外销',
          disabled: true
        }],
      jibie: [{
        value: '',
        label: '--请选择--'
      },],
      quyu: [{
        value: '',
        label: '--请选择--'
      },],
      //配置集合
      configlist: {},
      bizhongop: [{
        value: '',
        label: '--请选择--'
      },],
      all: "全部",
      formInline: {
        names: '',
        starttime: '',
        endtime: '',
        areaName: ''
      },
      day1:'',
      day2:'',
      options2: [],

      zy: {
          agentName:null,
          agentCode:null,
          salesregion:null,
          salesregionName:null,
          fileid: null,
          kehufujian:null,
          refid:false,
      },
      tableData3: [],
      delIds: [],

      oemTableData: [],
      optionsCustomer: [],
      optionsAgent: [],
      userCarePlan: {},
      rules: {
        materialDescrition: [{required: true, message: '请输入产品描述', trigger: 'change'}],
        materialCode: [{required: true, message: '请输入产品编码', trigger: 'change'}],
        agentName: [{required: true, message: '请选择经销商', trigger: 'change'}],

      },
      showshdfdialog: false,
      showwuliaodialog1: false,

      ddlx:'1,2',
      sceneList:[],//场景
      isShowChengbeng:true,//是否展示成本信息
       fwProdcut:{
        productName:null,
        productId:null,
        currency:null,
        unitPrice:null,
        customerName:null,
        customerCode:null,
      },
      resubmit: false,
    }
  },
  mounted() {
  },
  created() {
    this.showLevelName();


    //当前角色 如果有一下角色不允许展示成本信息
    if(this.$store.getters.hasRole('swyl_xiaoshoujl_wx') ){
      this.isShowChengbeng = false;
    }


    this.bizhongjiazai();

    this.options2 = this.$store.getters.dicts["userCareType"];

    if (this.$route.query) {

        let id = this.$route.query.ywid;
        let instid = this.$route.query.instid;
        //代办打开的
        if (id && instid) {
          this.resubmit = true;
        }

        this.kehufujian = this.$route.query.kehufujian || this.$util.getUuid();
        this.query(this.$router.history.current.query);

    }
  },
  beforeRouteLeave(to,from,next){
    if(to.path=='/chanp/priceManage' && from.path == '/chanp/priceChange'){
      to.meta.keepAlive = true;
    }else{
      to.meta.keepAlive = false;
    }
    next();
  },
  methods: {
    //查看进度
    chakanjindu(q){
      this.showinstid = q;
      this.showhistory = true;
    },


    fileBack1(v) {
       console.log(v)
       this.zy.kehufujian = v[0].refid;

    },

    dateChange1(val) {
      var dd = val.startdate;
      dd = dd.replace(/-/g, '/')
      var date =  new Date(dd);
      this.day1 = date.getTime();
      if (this.day2 < this.day1) {
        if (this.day2 == 0) {
          return;
        }
        this.$msg.msge("结束日期不能在开始日期之前");
        val.startdate = "";
      }
    },
    dateChange2(val) {
      var tt = val.effectivedate;
      tt = tt.replace(/-/g, '/')
      var date = new Date(tt);
      this.day2 = date.getTime()
      if (this.day2 < this.day1) {
        this.$msg.msge("结束日期不能在开始日期之前");
        val.effectivedate = "";
      }
    },
    //币种加载
    bizhongjiazai() {
      ss.Dictservice.listbycategory("YLCurrency").then(rd => {
        this.bizhongListops = rd;
      })
    },


    query(q) {
    //如果id不为空
      console.log("qqqqqq",q)

      if(q.ywid){
         q.shenpibanben = q.ywid;
      }

      if(q.shenpibanben){
        ss.companyPrice.selectByBanben(q.shenpibanben).then(rd => {
          if(rd.f){
            this.tableData3 = rd.obj;

            //上头内容
            this.$set(this.zy, "agentName",rd.obj[0].agentName);
            this.$set(this.zy, "agentCode",rd.obj[0].agentCode);
            this.$set(this.zy, "salesregion",rd.obj[0].salesregion);
            this.$set(this.zy, "salesregionName",rd.obj[0].salesregionName);
            this.$set(this.zy, "fileid",rd.obj[0].fileid);
            this.$set(this.zy, "kehufujian",rd.obj[0].kehufujian);

              //如果是海盛杰或者康盛的产品
              if(rd.obj[0].noHsjKs){
                  this.isHsjOrKs = false;
              }else{
                  this.isHsjOrKs = true;

              }
              //判断经销商是否有直单附件
              uploaddown.listdownfile({refid:rd.obj[0].fileid, reftype: '代理商注册-附件'}).then(res => {
                  if(res.obj.length>0){
                      this.zy.refid = true;
                  }
              })
          }

        });
      }

    },


    //删除框
    delPlan(index, q) {
      this.$confirm('确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
          .then(_ => {
            this.tableData3.splice(index, 1)
            if(q.id){
              this.delIds.push(q.id);
            }
          })
          .catch(_ => {
          });
    },
    //提交/暂存 按钮
    dingjiaanniu(q) {
      var subflag = false;
      this.$refs['zy'].validate((valid) => {
        if (valid) {
          subflag = true;
        } else {
          this.$msg.msge("请完善信息后再提交！");
          return false;
        }
      });

        //如果不是海盛杰康盛就校验附件
        if(!this.isHsjOrKs){
            //如果直单附件与附件都是空
            if(!this.zy.refid && !this.zy.kehufujian){
                this.$msg.msge("请上传附件后提交！");
                return false;
            }
        }


      if (subflag == true) {
        this.adddingjia(q);//暂存定价信息
      }
    },

    //发起定价
    adddingjia(q) {
      var canshu = [];

      if (this.tableData3.length > 0) {
        for (var t in this.tableData3) {
          canshu.push({
            protype:this.tableData3[t].protype,
            id: this.tableData3[t].id,
            materialCode: this.tableData3[t].materialCode,
            materialDescrition:this.tableData3[t].materialDescrition,
            agentCode: this.tableData3[t].agentCode,
            agentName: this.tableData3[t].agentName,
            salesregion:this.tableData3[t].salesregion,
            salesregionName:this.tableData3[t].salesregionName,

            leltypecode: this.tableData3[t].leltypecode,
            type: this.tableData3[t].jibie,
            value: this.tableData3[t].value,
            currency: this.tableData3[t].currency,
            startdate: this.tableData3[t].startdate,
            effectivedate: this.tableData3[t].effectivedate,
            ispass: this.tableData3[t].ispass,
            isuse: this.tableData3[t].isuse,
            oneLid : this.tableData3[t].oneLid,
            prodseries : this.tableData3[t].prodseries,
            instid : this.tableData3[t].instid,
            shenpibanben : this.tableData3[t].shenpibanben,
            zancun:q,
            delIds: this.delIds,
            kehufujian: this.zy.kehufujian,

          })
        }
        console.log("canshu",canshu);
        //如果是提交
          ss.companyPrice.adddingjia(canshu).then(rd => {
            if (q == 1) {
              this.$router.push({path: "/chanp/companyPriceManage"});
            }else{
              this.$router.push({path: "/chanp/companyPriceManage"});
            }

          })

      }else{
        this.$msg.alert("请新增公司定价!");
      }

    },

    //取消
    quxiao() {
      //this.$router.go(-1);
      this.$router.push({path: '/chanp/companyPriceManage'});

    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },


    //产品大类
    showLevelName() {
      ss.UserDemand.showLevelName().then(rd => {
        this.LevelName = rd;
      })
    },
    //选择经销商
    openShoudf() {

      this.showshdfdialog = true;
    },
    //选择经销商
    choseAgent(val) {
      this.showshdfdialog = false;
        this.zy.agentName = val.username;
        this.zy.agentCode = val.usercode;
        this.zy.salesregion = val.salesregion;
        this.zy.salesregionName = val.salesregionName;
        this.zy.fileid= val.fileid;
        this.tableData3 = [];
        //判断经销商是否有直单附件
        uploaddown.listdownfile({refid:val.fileid, reftype: '代理商注册-附件'}).then(res => {
            if(res.obj.length>0){
                this.zy.refid = true;
            }
        })
    },

      //选择物料
      showProcuct1() {
          if(!this.zy.agentCode){
              this.$msg.alert("请先选择经销商!");
              return false;
          }

          this.showwuliaodialog1 = true;
      },


    //根据根据编码查询物料信息
    selectListByCode(objs) {
        console.log("objsobjs",objs)

        this.showwuliaodialog1 = false;


       foo: for (var i = 0; i < objs.length; i++) {
            var addwl = objs[i];
             //重复校验
            var checkRepeat = false;
            this.tableData3.forEach(element => {
                if(addwl.matecode == element.materialCode){
                    checkRepeat =true;
                 }
            });

            if(checkRepeat){
                this.$msg.alert(addwl.matecode+"不可重复选择!");
                return false;
            }
            if(addwl.cpdlcode == 'ND1' ){
                // 看看产品列表里有没有其他产品
                for(var t=0;t<this.tableData3.length;t++){
                    var one = this.tableData3[t];
                    console.log("ND1",one.oneLid);
                    if(one.oneLid != 'ND1'){
                        this.$msg.msge("液氮罐系列产品不能跟其他产品一起定价，请单独定价！");
                        break foo;//跳出foo循环
                    }
                }
            }

            if(addwl.cpdlcode == 'KS1' ){
                // 看看产品列表里有没有其他产品
                for(var j=0;j<this.tableData3.length;j++){
                    var one = this.tableData3[j];
                    console.log("KS1",one.oneLid);
                    if(one.oneLid != 'KS1'){
                        this.$msg.msge("海盛杰系列产品不能跟其他产品一起定价，请单独定价！");
                        break foo;//跳出foo循环
                    }
                }
            }
            if(addwl.cpdlcode != 'KS1' && addwl.cpdlcode != 'ND1' ){
                // 看看产品列表里有没有其他产品
                for(var k=0;k<this.tableData3.length;k++){
                    var one = this.tableData3[k];
                    console.log("其他",one.oneLid);
                    if(one.oneLid == 'KS1' || one.oneLid == 'ND1' ){
                        this.$msg.msge(addwl.matecode+"该产品不能与海盛杰或康盛系列产品一起定价，请单独定价！");
                        break foo;//跳出foo循环
                    }
                }
            }

            var list = {
                materialCode: addwl.matecode,
                materialDescrition:addwl.matedes,
                agentName:this.zy.agentName,
                agentCode:this.zy.agentCode,
                oneLid : addwl.cpdlcode,
                prodseries : addwl.cpdlname,
                leltypecode: 1,
                leixingflag:'1',
                currency: 'CNY',
                value: '',
                salesregion:this.zy.salesregion,
                salesregionName:this.zy.salesregionName,
                youxiaoqi: '',
                effectivedate: '',
                startdate: '',
                ispass: '',
                fileid: this.zy.fileid,
                protype:addwl.protype,

            }
            console.log("list",list)
            this.tableData3.push(list)

        }
        console.log("this.tableData3",this.tableData3)
        //判断需定价的物料里有没有康盛海盛杰的物料
        if (this.tableData3.length > 0) {
            for(var i=0;i<this.tableData3.length;i++){
                if(this.tableData3[i].oneLid=='KS1' || this.tableData3[i].oneLid=='ND1'){
                    this.isHsjOrKs = true;
                }else{
                    this.isHsjOrKs = false;
                }

            }
        }


    },

  },
}
</script>
<style>

.weekplandetail14 .h-formbLine .el-form-item__label {
  width: 35%;
  text-align: right;
}

.weekplandetail14 .h-formbLine .el-form-item__content {
  width: 65%;
}

.weekplandetail14 .h-formbLine .h-elformWrap-2 {
  width: 33.333%;
}
.ljjtablepaddings12 .h-tableInput .el-input__inner{
  padding: 0.05rem 0.1rem;
}
.ljjtablepaddings12 .h-tableInput .el-input__icon{
  line-height: 0.25rem;
}

.ljj_selectdisblednone .el-input.is-disabled .el-input__inner{
  border-color: transparent;
}
.ljj_selectdisblednone.el-select .el-input.is-disabled .el-input__inner:hover{
  border-color: transparent;
}
.ljj_selectdisblednone .el-input__suffix{
  display: none;
}
</style>



